import type { ReactElement, ReactNode } from 'react';
import { cx } from './cx';
import s from './FieldWithAction.module.css';

export interface FieldWithActionProps {
  /** The field, or a few side by side. Their help and error text stay with each one. */
  children: ReactNode;
  /** The buttons that act on it: "Add a manual record", "Save view" and Cancel. */
  actions: ReactNode;
  /** The host's own look (a tinted panel); set --field-max-width here to keep a field short. */
  className?: string;
}

/**
 * A field with its buttons beside it, the buttons level with the input rather than with the help
 * or error text under it (APP-128). On a narrow card the buttons go under the fields.
 */
export function FieldWithAction({
  children,
  actions,
  className,
}: FieldWithActionProps): ReactElement {
  return (
    <div className={cx(s.row, className)}>
      <div className={s.fields}>{children}</div>
      <div className={s.actions}>{actions}</div>
    </div>
  );
}
